import { types as t, } from 'mobx-state-tree';

export default t.model("Address", {
	AddressId: t.identifierNumber,
	FirstName: t.maybeNull(t.string),
	LastName: t.maybeNull(t.string),
	EmailAddress: t.maybeNull(t.string),
	MobilePhoneNumber: t.maybeNull(t.string),
	PhoneNumber: t.maybeNull(t.string),

	Line1: t.maybeNull(t.string),
	Line2: t.maybeNull(t.string),
	PostalCode: t.maybeNull(t.string),
	City: t.maybeNull(t.string),
	CountryName: t.maybeNull(t.string),
	CountryISOCode: t.maybeNull(t.string),
	AddressName: t.maybeNull(t.string),
	CompanyName: t.maybeNull(t.string),

}).views(self => ({

})).actions(self => ({

}));
